// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Сповіщення» (Notifications, ключ `ntf`, група `settings`). */
export const notificationsManifest: IModuleManifest = {
  key: 'ntf',
  group: 'settings',
  slug: 'notifications',
  prefix: 'NTF',
  name: { en: 'Notifications', uk: 'Сповіщення' },
  entities: [
    { key: 'ntf', slug: 'ntf', name: { en: 'Notification rules', uk: 'Правила сповіщень' }, main: true },
    { key: 'ntftpl', slug: 'ntftpl', name: { en: 'Notification templates', uk: 'Шаблони сповіщень' }, main: false },
  ],
  loadState: () => import('./state/notificationsSlice').then((m) => m.notificationsSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
